import { useBoundStore } from "../store/useBoundStore";

const GLOBAL_DASH_INITIAL_AGENCY_DATE_RANGE_KEY = "globalDashboardInitialAgencyDateRange";

/**
 * Clears date-range state shared across Global / AM / EA dashboards.
 * Call on switch-user so one role's filter does not bleed into another.
 */
export const clearSharedDashboardDateState = () => {
  localStorage.removeItem("dateObj");
  localStorage.removeItem("dateObjRecentExtRaC");
  localStorage.removeItem("dateObjAgencySelectionAM");
  localStorage.removeItem(GLOBAL_DASH_INITIAL_AGENCY_DATE_RANGE_KEY);

  const store = useBoundStore.getState();
  if (typeof store.resetAMDashboardFilter === "function") {
    store.resetAMDashboardFilter();
  }
  if (typeof store.resetGlobalDashboardFilter === "function") {
    store.resetGlobalDashboardFilter();
  }
  if (typeof store.setFsFilters === "function") {
    store.setFsFilters({
      datemodified: {
        start_date: undefined,
        end_date: undefined,
      },
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/clearSharedDashboardDateState.js